import {styled} from "@mui/material/styles";
import React, {ReactEventHandler, useCallback} from "react";

import ModuleIcon from "../../assets/module-icon.svg";
import ProjectIcon from "../../assets/project-icon.svg";

const ThumbContainer = styled("div", {shouldForwardProp: (prop) => prop !== "thumbSize"})<{thumbSize: number}>(
    ({thumbSize}) => ({
        margin: "auto",
        width: `${thumbSize}px`,
        "& span": {display: "inline-block", height: "100%", verticalAlign: "middle"},
        "& img": {verticalAlign: "middle", width: `${thumbSize}px`, maxHeight: `${thumbSize}px`},
    }),
);

interface IDocumentThumbProps {
    thumbUrl: string | undefined;
    documentName: string;
    size?: number;
}

/**
 * Mirror of the main app's DocumentThumb + getPreviewUrl: preview image with a
 * project-folder icon when there is no preview (unpublished projects) and a
 * module icon on load error.
 */
function DocumentThumb(props: IDocumentThumbProps) {
    const {thumbUrl, documentName, size} = props;

    const thumbSize = size || 64;

    const injectDefaultModuleImage: ReactEventHandler<HTMLImageElement> = useCallback((event) => {
        event.currentTarget.src = ModuleIcon;
    }, []);

    return (
        <ThumbContainer thumbSize={thumbSize}>
            <span></span>
            {thumbUrl ? (
                <img
                    src={thumbUrl}
                    alt={documentName}
                    onError={injectDefaultModuleImage}
                    draggable={false}
                    width={thumbSize}
                    height={thumbSize}
                />
            ) : (
                <img src={ProjectIcon} alt={documentName} draggable={false} width={thumbSize} height={thumbSize} />
            )}
        </ThumbContainer>
    );
}

export default React.memo(DocumentThumb);
